import { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { LazyLoadImage } from "react-lazy-load-image-component";
// import { EmergingTechnologiesServiceData } from "../../common";
// core components
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import AboutUsBanner from "../../components/AboutUs/AboutUsBanner";
import CustomerReviews from "../../components/CustomerReviews/CustomerReviews";
import ContactUsComponent from "../../components/ContactUsComponent/ContactUsComponent";
import FrequentlyAskedQuestions from "../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions";
import TechIndustryQuality from "../../components/TechIndustryQuality/TechIndustryQuality";
// import { getIPGeoLocation } from "../../common/GeneralUtils";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import * as Icons from '../../common/icons/emergingTechnologiesServiceIcons';
import Toasts from "../../components/Toasts/Toasts";
// import { useLocation } from "react-router-dom";
// import { Helmet } from "react-helmet";
// import Loadable from "../../components/Loadable"

// const Header = Loadable(
//     lazy(() => import('../../components/header/header'))
// )
// const Footer = Loadable(
//     lazy(() => import('../../components/footer/footer'))
// )
// const AboutUsBanner = Loadable(
//     lazy(() => import('../../components/AboutUs/AboutUsBanner'))
// )
// const CustomerReviews = Loadable(
//     lazy(() => import('../../components/CustomerReviews/CustomerReviews'))
// )
// const ContactUsComponent = Loadable(
//     lazy(() => import('../../components/ContactUsComponent/ContactUsComponent'))
// )
// const FrequentlyAskedQuestions = Loadable(
//     lazy(() => import('../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions'))
// )
// const TechIndustryQuality = Loadable(
//     lazy(() => import('../../components/TechIndustryQuality/TechIndustryQuality'))
// )

const EmergingTechnologiesServiceScreen = () => {
    // const location = useLocation();
    const [toasts, setToasts] = useState(null)
    const [WebAppDevelopmentData, setData] = useState({});
    const [EmergingTechnologiesServiceData, setEmergingTechnologiesServiceData] = useState({});
    const [geoLocationData, setGeoLocationData] = useState(null);

    const getAllWebAppDevelopmentData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/webAppDevelopmentData.json');
            setData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }
    const getAllEmergingTechnologiesServiceData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/emergingTechnologiesServiceData.json');
            setEmergingTechnologiesServiceData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }

    useEffect(() => {
        // getIPGeoLocation(location.pathname);
        getAllWebAppDevelopmentData();
        getAllEmergingTechnologiesServiceData();
    }, [])
    return (
        <Fragment>
            <Helmet>
                <title>Emerging Technologies Service for Future-Ready Businesses</title>
                <meta name="description" content="VarahiSoft offers emerging technologies service to help businesses innovate with AI, IoT, blockchain and next-gen digital solutions." />
                <meta name="keywords" content="Emerging Technologies Service" />
                <meta property="og:title" content="Emerging Technologies Service for Future-Ready Businesses" />
            </Helmet>
            <div id="main-wrapper">
                <Header geoLocation={setGeoLocationData} />
                <div className="page-wrapper emerging-technologies-service-page-wrapper">
                    <div className="container-fluid">
                        <div className="page-content-top">
                            <AboutUsBanner bannerImg={EmergingTechnologiesServiceData?.bannerImg} data={EmergingTechnologiesServiceData?.headerData} />
                            <section className="revolutionize">
                                <Container>
                                    <Row>
                                        <Col lg={6} md={6} sm={6}>
                                            <div className="img-div-width">
                                                <LazyLoadImage
                                                    alt={'image'}
                                                    className="w-100"
                                                    effect="blur"
                                                    src={EmergingTechnologiesServiceData?.revolutionizeData?.pageImg} // use normal <img> attributes as props
                                                />
                                            </div>
                                        </Col>
                                        <Col lg={6} md={6} sm={6}>
                                            <div className="revolutionize-content">
                                                <h2>{EmergingTechnologiesServiceData?.revolutionizeData?.title}</h2>
                                                {EmergingTechnologiesServiceData?.revolutionizeData?.textData?.length > 0 && EmergingTechnologiesServiceData?.revolutionizeData?.textData?.map((text, index) => <p key={index}>{text.text}</p>)}
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </section>
                            <section className="why-emerging-technologies-service-matters">
                                <Container>
                                    <div className="why-emerging-technologies-body">
                                        <h3>{EmergingTechnologiesServiceData?.whyEmergingTechnologiesServiceMattersData?.title}</h3>
                                        <p>{EmergingTechnologiesServiceData?.whyEmergingTechnologiesServiceMattersData?.subTitle}</p>
                                        <Row>
                                            {EmergingTechnologiesServiceData?.whyEmergingTechnologiesServiceMattersData?.listData?.map((cardItem, index) => {
                                                return <Col key={index} lg={3} md={3} sm={6}>
                                                    <Card className="app-card mb-0 mt-4">
                                                        <CardBody>
                                                            <h4 className="card-title-div">{cardItem?.title}</h4>
                                                            <p>{cardItem?.text}</p>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            })}
                                        </Row>
                                    </div>
                                </Container>
                            </section>
                            <section className="core-pillars-screen">
                                <Container>
                                    <div className="core-pillars-header mb-5">
                                        <h3>{EmergingTechnologiesServiceData?.corePillarsData?.title} <br /> {EmergingTechnologiesServiceData?.corePillarsData?.subTitle}</h3>
                                    </div>
                                    <Row>
                                        <Col className="core-pillars-warper px-5" lg={6} md={6}>
                                            <div className="core-pillars-warper-inner px-5">
                                                <p>{EmergingTechnologiesServiceData?.corePillarsData?.text}</p>
                                                <ul>
                                                    {EmergingTechnologiesServiceData?.corePillarsData?.listData?.map((para, index) => {
                                                        return (
                                                            <li className="core-pillars-warper-body mb-3 pe-3" key={index}>
                                                                <h4 className="m-0">{para?.title}</h4>
                                                                <span>{para?.text}</span>
                                                            </li>
                                                        )
                                                    })}
                                                </ul>
                                            </div>
                                        </Col>
                                        <Col lg={6} md={6} className="m-auto text-start">
                                            <div className="img-div-width">
                                                <LazyLoadImage
                                                    alt={'image'}
                                                    className="w-100"
                                                    effect="blur"
                                                    src={EmergingTechnologiesServiceData?.corePillarsData?.pageImg} // use normal <img> attributes as props
                                                />
                                            </div>
                                            {/* <img src={tech?.pageImg} alt="img" /> */}
                                        </Col>
                                    </Row>
                                </Container>
                            </section>
                            <section className="core-mobile-app-section">
                                <Container>
                                    <h3 className="text-center">{EmergingTechnologiesServiceData?.breakthroughResultsData?.title}</h3>
                                    <p className="text-center">{EmergingTechnologiesServiceData?.breakthroughResultsData?.subTitle}</p>
                                    <div className="core-mobile-app-card">
                                        <Row className="m-0">
                                            {EmergingTechnologiesServiceData?.breakthroughResultsData?.listData?.map((cardItem, index) => {
                                                const Icon = Icons[cardItem?.icon] || null;
                                                return <Col key={index} md={4} lg={4} sm={6} xs={12}>
                                                    <Card className="app-card">
                                                        <CardBody>
                                                            <p>
                                                                {Icon && <Icon />}
                                                            </p>
                                                            <h4 className="card-title-div">{cardItem?.title}</h4>
                                                            <p><span>{cardItem?.text}</span>{cardItem?.bold && <span>{cardItem?.bold}</span>}{cardItem?.text1 && <span>{cardItem?.text1}</span>}</p>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            })}
                                        </Row>

                                    </div>
                                </Container>
                            </section>
                            <section className="core-mobile-app-process" >
                                <Container>
                                    <h3>{EmergingTechnologiesServiceData?.WhyChooseVarahiSoftforECommerceDevelopment?.title}</h3>
                                    <h4 className="pe-5">{EmergingTechnologiesServiceData?.WhyChooseVarahiSoftforECommerceDevelopment?.subTitle}</h4>
                                    <div className="core-mobile-app-card pt-5">
                                        <Row>
                                            <Col lg={6} md={6} xs={12} className="d-flex align-items-center">
                                                <div className="img-div-width">
                                                    <LazyLoadImage
                                                        alt={'image'}
                                                        className="w-100"
                                                        effect="blur"
                                                        src={EmergingTechnologiesServiceData?.WhyChooseVarahiSoftforECommerceDevelopment?.pageImg} // use normal <img> attributes as props
                                                    />
                                                </div>
                                            </Col>
                                            <Col className="content-body" lg={6} md={6} xs={12}>
                                                {EmergingTechnologiesServiceData?.WhyChooseVarahiSoftforECommerceDevelopment?.listData?.map((chooseData, index) => {
                                                    const ChooseDataIcon = Icons[chooseData?.icon] || null;
                                                    return (
                                                        <div key={index} className="px-5 d-flex align-items-start justify-content-start gap-3">
                                                            <div className="why-choose-icon">{ChooseDataIcon && <ChooseDataIcon />}</div>
                                                            <div className="why-cho0se-body">
                                                                <h5>
                                                                    {chooseData?.title}
                                                                </h5>
                                                                <p>{chooseData?.text}</p>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </Col>
                                        </Row>
                                    </div>
                                </Container>
                            </section>
                            <TechIndustryQuality techIndustryQualityData={EmergingTechnologiesServiceData?.techIndustryQualityData} />
                            <CustomerReviews />
                            <div className="home-contact-page">
                                <ContactUsComponent setToasts={setToasts} GeoIpData={geoLocationData} />
                            </div>
                            <FrequentlyAskedQuestions faqData={WebAppDevelopmentData?.FrequentlyAskedQuestionsData} />
                        </div>
                    </div>
                </div>
                <Footer />
                {toasts && <Toasts toastsList={toasts} />}
            </div>
        </Fragment>
    );
}

EmergingTechnologiesServiceScreen.propTypes = {
    classes: PropTypes.object
};

export default EmergingTechnologiesServiceScreen;
